import { render, staticRenderFns } from "./MessageApproval.vue?vue&type=template&id=3e2785b9"
import script from "./MessageApproval.ts?vue&type=script&lang=ts&external"
export * from "./MessageApproval.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports